import { Pipe, PipeTransform } from '@angular/core';

export interface PageRangeInput {
  pageNumber: number;
  pageSize: number;
  totalRecords: number;
}

@Pipe({
  name: 'pageRange',
  standalone: true,
})
export class PageRangePipe implements PipeTransform {
  transform(value: PageRangeInput | null | undefined): string {
    if (!value || value.totalRecords === 0) {
      return '0';
    }

    const start = (value.pageNumber - 1) * value.pageSize + 1;
    const end = Math.min(value.pageNumber * value.pageSize, value.totalRecords);
    return `${start}–${end}`;
  }
}
